<template>
  <div>
    <Input title="Emails" :loading="loading" placeholder="example.com" description="See which emails Webscout has observed on any given domain." @submit="handle"/>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Input from '@/components/Blocks/Box/Input.vue'
import { useQueryStore } from '@/stores/query'
import { useMainStore } from '@/stores/main'
import Domain from '@/api/Domain'
import CellExpandedSlideover from '@/components/Query/CellDataSlideover.vue'
let mainStore = useMainStore()
let queryStore = useQueryStore()
import QueryRunner from '@/views/Authenticated/Query/Runner.vue'

const loading = ref(false)

async function handle(domain) {
  domain = domain.toLowerCase()
  mainStore.show_slideover(QueryRunner, { input: [domain], type: "emails" }, { width: 10 }, "(emails) " + domain) 
}
</script>

<style scoped>

</style>
